import styled from 'styled-components';
import { colors, spacing, font, breakpoints, themes } from '@chegg-ui/theme';

export const BulletList = styled.ul`
  padding: 0;
  width: 100%;
  list-style-type: none;
  font-size: ${font.size.px16};
  font-weight: 500;
  margin: ${spacing.px24} 0;
  border-top: 1px solid ${colors.white};
`;

export const Container = styled.div`
  z-index: 1;
  width: 360px;
  display: flex;
  height: max-content;
  align-items: center;
  flex-direction: column;
  color: ${colors.white};
  backdrop-filter: blur(5px);
  padding: ${spacing.px48} ${spacing.px24};
  margin: 0 ${spacing.px24};
  font-family: ${font.family.default};
  background-color: rgba(0, 0, 0, 0.8);

  &.simplifiedstudy,
  &.pla {
    color: ${colors.dark};
    padding: ${spacing.px48} 0;
    background-color: ${colors.white};

    ${BulletList} {
      margin: 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm.max}) {
    padding: ${spacing.px48} ${spacing.px16};
    margin: 0;
    width: auto;
    &.simplifiedstudy,
    &.pla {
      padding: ${spacing.px48} ${spacing.px24};
    }
  }
`;
export const Header = styled.h5`
  margin: 0;
  text-align: center;
  font-size: ${font.size.px22};
  font-weight: ${font.weight.bold};
  line-height: ${themes.horizon.font.lineHeight.sm};
  letter-spacing: 0;
`;

export const SubHeader = styled.p`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: ${spacing.px8} 0 0 0;
  font-size: ${font.size.px12};
  font-weight: ${font.weight.bold};
  line-height: ${themes.horizon.font.lineHeight.sm};
  letter-spacing: ${themes.horizon.font.letterSpacing.lg};
`;

export const Bullet = styled.li`
  display: flex;
  grid-gap: ${spacing.px24};
  align-items: center;
  margin: ${spacing.px16} 0;
  font-size: ${font.size.px16};
  line-height: ${themes.horizon.font.lineHeight.sm};
  letter-spacing: ${themes.horizon.font.letterSpacing.md};
  font-weight: ${font.weight.normal};
  &:last-child {
    margin: 0;
  }
`;

export const Footer = styled.div`
  font-size: ${font.size.px12};
  font-weight: ${font.weight.bold};
  line-height: ${themes.horizon.font.lineHeight.sm};
  letter-spacing: ${themes.horizon.font.letterSpacing.lg};
`;

export const IconBox = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const NewIcon = styled.div`
  font-size: ${font.size.px12};
  padding: ${spacing.px4} ${spacing.px8};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
`;

export const NewIconText = styled.span`
  margin-top: 0.2rem;
`;
